module.exports = __webpack_public_path__ + "img/logo.3a720db2.jpg";